package fr.frux.core.database

import kotlin.Long
import kotlin.String

public data class Cluster_pyramid_cache(
  public val id: Long,
  public val etag: String?,
  public val payload: String,
  public val checked_at: Long,
)
